var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.636,
    height: 20.324,
    viewBox: "0 0 16.636 20.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-navigation-documents-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2051",
    "data-name": "Rectangle 2051",
    width: 16.636,
    height: 20.324,
    fill: "#c5c9f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22690",
    "data-name": "Group 22690",
    clipPath: "url(#clip-path-navigation-documents-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    d: "M123.963,108.4h-.594V123a1.762,1.762,0,0,1-1.759,1.759H110.8v.541a1.123,1.123,0,0,0,1.123,1.123h12.038a1.123,1.123,0,0,0,1.123-1.123V109.523a1.121,1.121,0,0,0-1.121-1.123",
    transform: "translate(-108.448 -106.099)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M7.14,18.024h6.019A1.123,1.123,0,0,0,14.282,16.9V1.123A1.123,1.123,0,0,0,13.159,0H5.138V.371A1.091,1.091,0,0,1,5.145.49V3.566A1.582,1.582,0,0,1,3.564,5.147H.488c-.032,0-.066,0-.1,0H0V16.9a1.123,1.123,0,0,0,1.123,1.123H7.14Zm.227-3.816H3.443a.531.531,0,0,1,0-1.061H7.369a.531.531,0,1,1,0,1.061M11.293,11.5H3.443a.531.531,0,0,1,0-1.061h7.851a.531.531,0,1,1,0,1.061M3.443,7.562h7.851a.531.531,0,1,1,0,1.061H3.443a.531.531,0,0,1,0-1.061",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M1.12,5.293H4.2a.942.942,0,0,0,.934-.934V1.273A.472.472,0,0,0,4.663.8a.46.46,0,0,0-.331.14L.785,4.487a.473.473,0,0,0,.335.807",
    transform: "translate(-0.632 -0.783)",
    fill: "#c5c9f6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.09e11a21d71d64d5a6614243f413de92.svg";
export { ForwardRef as ReactComponent };